var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderFeeL1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.67188 2.86328H12.4648L14.4648 6.03516L8.06836 13.4738L1.67188 6.03516L3.67188 2.86328Z",
    fill: "url(#paint0_linear_4948_6227)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91406 6.40039L8.06641 8.55273L10.2188 6.40039",
    stroke: "white",
    strokeLinejoin: "bevel"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4948_6227",
    x1: 14.4648,
    y1: 6.68732,
    x2: 8.06836,
    y2: 13.4738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEC47E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C49A42"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderFeeL1);
export default __webpack_public_path__ + "static/media/header-fee-l1.910373581ec3a6553aad852e52438aa5.svg";
export { ForwardRef as ReactComponent };